import { graphql } from "../__generated__";

export const OrganizationFragment = graphql(`
  # import useSelectTranslationStringInput from '../../languages/fragments.ts/0_document.graphql'
  fragment Organization on Organization {
    id
    coachingEnabled
    coachingsPerHuman
    code
    color
    consultsPerHuman
    creditsPerHuman
    mindlabBusinessId
    mindlabEnabled
    slug
    ssoEnabled
    videoEnabled
    logoUrl {
      ...useSelectTranslationStringInput
    }
    name {
      ...useSelectTranslationStringInput
    }
  }
`);
